import PhoneNumber from "awesome-phonenumber";

export const isValidPhoneNumber = (value) => {
  if (!value) return false;

  // 去除空格、括号、横杠等符号
  let cleanValue = value.replace(/[-\s().]/g, "");

  // 如果没有 "+" 开头，尝试加上国际区号（默认 +86 或你也可以用其他国家）
  if (!cleanValue.startsWith("+")) {
    cleanValue = "+" + cleanValue;
  }

  const phoneNumber = PhoneNumber(cleanValue);

  // 判断是否为有效号码
  return phoneNumber.valid;
};

export const isValidEmail = (value) => {
  if (!value) return false;
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  if (reg.test(value)) {
    return true;
  }
};

export const isValidPassword = (value) => {
  if (!value) return false;
  const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/;
  if (reg.test(value)) {
    return true;
  }
};
